<table mat-table [dataSource]="accessList" class="full-width">
    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef> Utilisateur</th>
      <td mat-cell *matCellDef="let access">
        <div *ngIf="access !== newAccess">{{access.firstname}} {{access.lastname}}</div>
        <app-user-selection *ngIf="access === newAccess" style="width:100%;" (selected)="selectUser($event)" [label]="'Utilisateur'" [mode]="'list'" [userClass]="'SNItem.SNUser.CNUser'"></app-user-selection>
      </td>
    </ng-container>
    <ng-container matColumnDef="read">
      <th mat-header-cell *matHeaderCellDef> Lecture </th>
      <td mat-cell *matCellDef="let access"> <mat-slide-toggle [checked]="access.read" (change)="changeReadAccess(access,$event)"></mat-slide-toggle> </td>
    </ng-container>
    <ng-container matColumnDef="write">
      <th mat-header-cell *matHeaderCellDef> Ecriture </th>
      <td mat-cell *matCellDef="let access"> <mat-slide-toggle [checked]="access.write" (change)="changeWriteAccess(access,$event)"></mat-slide-toggle> </td>
    </ng-container>
    <ng-container matColumnDef="change">
      <th mat-header-cell *matHeaderCellDef> Ajouter </th>
      <td mat-cell *matCellDef="let access"> <mat-slide-toggle [checked]="access.change"></mat-slide-toggle> </td>
    </ng-container>
    <ng-container matColumnDef="locked">
        <th mat-header-cell *matHeaderCellDef> Verrou </th>
        <td mat-cell *matCellDef="let access"> <mat-slide-toggle [checked]="access.locked"></mat-slide-toggle> </td>
    </ng-container>    
    <ng-container matColumnDef="icons">
      <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
      <td mat-cell *matCellDef="let access">
        <button mat-icon-button *ngIf="access !== newAccess"><fa-icon [icon]="['fas','trash']" size="lg"></fa-icon></button>
        <button mat-icon-button *ngIf="access === newAccess" (click)="add()" [disabled]="!selectedUser"><fa-icon [icon]="['fas','plus-circle']" size="lg"></fa-icon></button>
      </td>
    </ng-container>    
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>